import type { DriveStep } from 'driver.js';

export const staffScannerTourId = 'staff:scanner';

export const staffScannerSteps: DriveStep[] = [
  {
    element: '[data-tour="staff:scanner-camera"]',
    popover: {
      title: 'QR-сканер',
      description:
        'QR-сканер. Наведите камеру на QR-код клиента — система автоматически проверит подлинность и покажет данные заказа.',
    },
  },
  {
    element: '[data-tour="staff:scanner-manual"]',
    popover: {
      title: 'Ручной поиск',
      description:
        'Ручной поиск. Если QR-код не работает — введите номер заказа вручную.',
    },
  },
  {
    element: '[data-tour="staff:help-btn"]',
    popover: {
      title: 'Помощь',
      description: 'Кнопка помощи.',
    },
  },
];
